(function () {
    'use strict';

    function formSearch($rootScope, searchDataService, searchService) {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/formSearch.html',
            scope: {
                searchControlId: '@',
                results: '=',
                searchConfiguration: '=',
                sessionData: '=',
                showResults: '=',
                attributes: '=',
                additionalQueryString: '@?',
                pageSize: '=?',
                pageNum: '=?',
                totalItems: '=?'
            },
            link: function (scope, element, attrs) {
                scope.showResults = true;

                if (!attrs.searchControlId) {
                    scope.searchControlId = 'searchControlId';
                }

                scope.queryModel = {
                    entity: scope.searchConfiguration.Entity,
                    uri: scope.searchConfiguration.Uri,
                    pageSize: scope.pageSize || 10,
                    pageNum: scope.pageNum || 0,
                    numPages: 0,
                    orderBy: scope.searchConfiguration.DefaultOrderBy,
                    orderByDirection: scope.searchConfiguration.DefaultOrderByDirection.toLowerCase(),
                    predicates: {},
                    injectedPredicates: scope.searchConfiguration.InjectedSearchCriteria,
                    defaultPredicates: scope.searchConfiguration.DefaultSearchCriteria
                };

                if (scope.additionalQueryString) {
                    scope.queryModel.additionalQueryString = scope.additionalQueryString;
                }

                scope.pageSizes = [5, 10, 15, 20, 25];

                scope.searchConfiguration.SearchCriteria.forEach(function (item) {
                    scope.queryModel.predicates[item.SearchFieldName] = {
                        value: item.SearchCondition === 'In' ? item.PresetValues : item.PresetValues.length > 0 ? item.PresetValues[0] : null,
                        condition: item.SearchCondition,
                        watch: function () { return true; }
                    }
                });

                scope.$watch(function () { return scope.queryModel; },
                    function () {
                        getSearchResults(scope.queryModel);
                    }, true);

                $rootScope.$on('pageIndexChanged', function (event, args) {
                    if (args.searchControlId === scope.searchControlId) {
                        scope.queryModel.pageNum = args.pageIndex;
                    }
                });

                $rootScope.$on('pageSizeChanged', function (event, args) {
                    if (args.searchControlId === scope.searchControlId) {
                        scope.queryModel.pageSize = args.pageSize;
                        scope.queryModel.pageNum = args.pageIndex;
                    }
                });

                function getSearchResults() {
                    searchDataService.getResults(scope.queryModel).then(function (data) {
                        scope.results = data.Results;
                        scope.totalItems = data.TotalResults;
                        $rootScope.$emit('searchResultsChanged', {
                            searchControlId: scope.searchControlId,
                            results: scope.results,
                            totalItems: scope.totalItems
                        });
                    });

                    scope.attributes = searchService.getAttributes(scope.queryModel.predicates);
                }
            }
        };
    }

    formSearch.$inject = ['$rootScope', 'searchDataService', 'searchService'];

    angular.module('ecap.common').directive('formSearch', formSearch);
})();